export default {
  // Common
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  create: 'Create',
  close: 'Close',
  search: 'Search',
  filter: 'Filter',
  loading: 'Loading...',
  noData: 'No data',
  retry: 'Retry',
  confirm: 'Confirm',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  yes: 'Yes',
  no: 'No',
  all: 'All',
  required: 'Required',
  optional: 'Optional',

  // Auth
  login: 'Log in',
  logout: 'Log out',
  email: 'Email',
  password: 'Password',
  forgotPassword: 'Forgot your password?',
  resetPassword: 'Reset password',
  register: 'Register',
  wrongCredentials: 'Invalid credentials',
  accountLocked: 'Account temporarily locked',
  sessionExpired: 'Your session has expired',

  // Navigation
  dashboard: 'Dashboard',
  requests: 'Requests',
  clients: 'Clients',
  professionals: 'Professionals',
  vehicles: 'Vehicles',
  calendar: 'Calendar',
  billing: 'Billing',
  invoices: 'Invoices',
  quotes: 'Quotes',
  settings: 'Settings',
  reporting: 'Reports',
  checklists: 'Checklists',
  support: 'Support',

  // Request statuses
  status: {
    requested: 'Requested',
    quoted: 'Quoted',
    accepted: 'Accepted',
    pending_payment: 'Pending Payment',
    ready: 'Ready',
    active_service: 'Active',
    completed: 'Completed',
    rejected: 'Rejected',
    archived: 'Archived',
    cancelled: 'Cancelled',
    paid: 'Paid',
    sent: 'Sent',
    draft: 'Draft',
    overdue: 'Overdue',
  },

  // Roles
  role: {
    superadmin: 'Super Admin',
    admin: 'Administrator',
    client: 'Client',
    professional: 'Professional',
    ambulance: 'Resource/Ambulance',
  },

  // Actions
  generateQuote: 'Generate quote',
  sendQuote: 'Send quote',
  signQuote: 'Sign quote',
  rejectQuote: 'Reject quote',
  prepareService: 'Prepare service',
  activateService: 'Activate service',
  finishService: 'Finish service',
  assignVehicle: 'Assign vehicle',
  assignProfessional: 'Assign professional',
  autoAssign: 'Auto-assign',
  validatePayment: 'Validate payment',
  downloadPdf: 'Download PDF',
  archive: 'Archive',
  reopen: 'Reopen',

  // Notifications
  notification: {
    newRequest: 'New request',
    quoteSigned: 'Quote signed',
    newInvoice: 'New invoice',
    serviceActivated: 'Service activated',
    serviceCompleted: 'Service completed',
    assignmentProposed: 'New assignment proposed',
    markAllRead: 'Mark all as read',
    noNotifications: 'No notifications',
  },

  // Invoice
  invoice: {
    number: 'Invoice number',
    concept: 'Concept',
    amount: 'Amount',
    issueDate: 'Issue date',
    dueDate: 'Due date',
    overdue: 'Overdue',
    dueSoon: 'Due soon',
    subtotal: 'Subtotal',
    tax: 'VAT',
    total: 'Total',
  },

  // Professional
  professional: {
    specialization: 'Specialization',
    hoursWorked: 'Hours worked',
    totalEarned: 'Total earned',
    settlements: 'Settlements',
    availability: 'Availability',
    pendingProposals: 'Pending proposals',
    accept: 'Accept',
    reject: 'Reject',
    countdown: 'Time remaining',
  },

  // Resource / Ambulance
  resource: {
    departureBase: 'Base departure',
    enRoute: 'En route',
    arrival: 'Arrival',
    onSite: 'On site',
    finishing: 'Finishing',
    returnBase: 'Return to base',
    closed: 'Closed',
    estimatedDeparture: 'Estimated departure time',
    crewSignature: 'Crew signature',
    checklist: 'Equipment checklist',
    incidents: 'Incidents',
  },

  // Errors
  error: {
    generic: 'Something went wrong. Please try again.',
    network: 'Connection error. Check your internet.',
    notFound: 'Not found',
    forbidden: 'You do not have permission for this action',
    validation: 'Please check the highlighted fields',
  },

  // Time
  time: {
    now: 'now',
    minutesAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    today: 'Today',
    tomorrow: 'Tomorrow',
    inDays: 'In {n} days',
  },
};
